var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefits-list__card"},[_c('div',{staticClass:"benefits-list__card__icon"},[_c('img',{attrs:{"src":require(`@/assets/svg/icons-general-${_vm.icon}.svg`),"alt":_vm.icon}})]),_c('div',{staticClass:"benefits-list__card__text"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }